module.exports = __webpack_public_path__ + "static/media/somethingishouldknow.c3e1b0b5.png";